import React from "react";
import styled from "styled-components";
import BREAKPOINTS from "../../constants/breakpoints";

const BoxContainer = styled.div`
  position: relative;
  margin: 0.5rem auto 1rem;
  width: 100%;
  max-width: ${(props) => (props.boxWidth ? props.boxWidth : "100%")};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    width: ${(props) => (props.boxWidth ? props.boxWidth : "100%")};
  }
`;

const BoxTitle = styled.div`
  font-family: "Press Start 2P", cursive;
  font-size: 0.5625rem;
  position: absolute;
  top: -0.2rem;
  left: 1rem;
  background: ${(props) => props.theme.colors.main};
  color: ${(props) => props.theme.colors.second};
  padding: 0 0.25rem;
  text-transform: uppercase;
`;

const BoxContent = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 1rem;
  border: 2px solid white;
  border-radius: 0.5rem;
  overflow: auto;
`;

const Box = ({ title, id, boxWidth, style, centerContent, children }) => {
  return (
    <BoxContainer id={id} boxWidth={boxWidth} style={style}>
      <BoxTitle>{title}</BoxTitle>
      <BoxContent
        style={{
          justifyContent: centerContent ? "center" : "flex-start",
        }}
      >
        {children}
      </BoxContent>
    </BoxContainer>
  );
};

export default Box;
